export default function isDate(input) {
    return (
        input instanceof Date ||
        Object.prototype.toString.call(input) === '[object Date]'
    );
}



//////////////////
// WEBPACK FOOTER
// ./~/moment/src/lib/utils/is-date.js
// module id = 656
// module chunks = 3